import Qrcode from '../../../core/qrcode';
import React from 'react';
import { Link } from 'react-router-dom';
import  SimpleReactValidator from 'simple-react-validator';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import Preloader from '../../../core/Preloader';
import { viewData, processData } from '../../../core/HttpAction';
import {permissionCheck} from '../../../core/Permission';
import Nopermission from '../../../core/Nopermission';
import Autocomplete from 'react-autocomplete';
import axiosCancel from 'axios-cancel';
import xhr from '../../../core/Http';
import toast from '../../../core/toast'; 

const Url='/book-issue-return';
const backUrl='/library'+Url;
const menuUrl='/getallbookcategory';
const memberUrl='/get-users';
const booksUrl='/books';
const qrcodeUrl='/qrcode';
 

class AddEditAction extends React.Component {
    constructor(props) {
        super(props); 
        this.state={
            member_type:'student', 
            book_name:'',
            bookList:[],
            issue_date:moment(new Date()),
            return_date:null,
            status:1, 
            memberList:[],
            member_name:'',
            no_days:0,
            quantity:0,
            id_no:'',
            issuedCount:0,
            availableCount:0,
            book_status:0,
            qr_code:false,
            book_quantity_detail_id:0,
            accessCode:'',
            bookQuantityData:[],
            accessView:false,
            preloader:this.props.match.params.id?true:false,
            pagetitle:this.props.match.params.id?'Edit':'New'
        };
        this.validator = new SimpleReactValidator();
        this.onChangetext=this.onChangetext.bind(this);
        this.onChangeBook=this.onChangeBook.bind(this);
    }


    componentDidMount(){

        viewData(menuUrl).then((res)=>{
            if(res.data.status===200){
                let datam =res.data.data;
                this.setState({bookCategoryData:datam});
                if(this.props.match.params.id){
                    viewData(Url+'/'+this.props.match.params.id).then((res)=>{
                        if(res.data.status===200){
                            let data=res.data.data;
                            let bookData =res.data.bookData; 
                            this.setState({
                                book_id:data.book_id?data.book_id:'', 
                                member_id:data.member_id?data.member_id:'', 
                                book_name:data.book_name?data.book_name:'', 
                                member_type:data.member_type?data.member_type:'', 
                                member_name:data.member_name?data.member_name:'', 
                                issue_date:data.issue_date?moment(new Date(data.issue_date)):'', 
                                return_date:data.return_date?moment(new Date(data.return_date)):'',  
                                quantity:bookData.quantity, 
                                issuedCount:bookData.issued_count, 
                                availableCount:bookData.availability_count, 
                                book_quantity_detail_id:bookData.book_quantity_detail_id, 
                                book_status:data.book_status,
                                id_no:data.id_no,
                                preloader:false, 
                            });
                        }
                    });
                }
            }
        });
    }
 
    setStateFromInput=(event)=> {
        var obj = {};
        obj[event.target.name] =event.target.name==='status'?event.target.value==0?1:0:event.target.value;
        if(event.target.name==='member_type'){
            obj['member_name']=''; 
            obj['memberList']=[];
        }
        this.setState(obj);
    }

    submitForm=()=>{
        if( this.validator.allValid() ){
            const { id_no,book_name,issue_date,status,return_date,book_id,member_id,member_name,member_type,book_quantity_detail_id} = this.state;
 
            let params={
                book_name,
                issue_date:moment(issue_date),
                return_date:moment(return_date),
                book_id,member_id,member_name,member_type,book_quantity_detail_id,
                id_no,
                status
            }; 
            let para=this.props.match.params.id?'/'+this.props.match.params.id:'';
            processData(Url+para,params).then((res)=>{
                if(res.data.status===200){
                    this.props.history.push(backUrl);
                } else{
                    const msg =res.data.message?res.data.message:'Please enter required feilds...';                     alert(msg);
                    this.setState({error_status:true,preloader:false});
                }
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    handleEntryDate=(date)=>{
        /* var myDate = new Date(new Date(date).getTime()+this.state.no_days*24*60*60*1000);
        this.setState({issue_date: date,return_date:moment(myDate).format('DD/MM/YYYY')}); */
    } 
    onChangetext( e ) {
        const member_type=this.state.member_type;
        if(!member_type)
            alert('Please select member type');

        this.setState({loading:true,loader:true,member_name:e.target.value});
        axiosCancel(xhr, { debug: false});
        const requestId = 'membersuggest';
        xhr.get(memberUrl,{params:{search_term:e.target.value,member_type:member_type}},{requestId:requestId}).then((res)=>{
            let data=res.data.data;
            if(data){ 
                let options=[];
                data.map((val,i)=>{
                    options.push({ value:val.name,result:val});
                });
                this.setState({loading:false,loader:false,memberList:options,selected:[]});
            }
        }); 
        xhr.cancel(requestId);
    }

    onChangeBook( e ) {
        this.setState({loading:true,loader:true,book_name:e.target.value});
        axiosCancel(xhr, { debug: false});
        const requestId = 'booksuggest';
        xhr.get(booksUrl,{params:{search_term:e.target.value}},{requestId:requestId}).then((res)=>{
            let data=res.data.data;
            if(data){ 
                let options=[];
                data.map((val,i)=>{
                    options.push({ value:val.title,result:val});
                });
                this.setState({loading:false,loader:false,bookList:options,selected:[]});
            }
        }); 
        xhr.cancel(requestId);
    }

    onSelectedtext(user_name,val) {
        const { user_id,id_no } =val.result; 
        this.setState({member_name:user_name,member_id:user_id,id_no,memberList:[] });
    }
   
    onSelectedBook(bookTitle,val) {
        const { book_id,no_of_due_days_student,no_of_due_days_staff,issuedCount,quantity,book_quantity_detail_id } =val.result; 
        const no_days=this.state.member_type==='student' ? no_of_due_days_student:no_of_due_days_staff;
        this.setState({preloader:true});
        viewData('/book-quantity/available/'+book_id).then((res)=>{
            if(res.data.status===200){  
                const {issue_date}=this.state;
                var myDate = new Date(new Date(issue_date).getTime()+no_days*24*60*60*1000);
                this.setState({book_name:bookTitle,book_id:book_id,bookList:[],no_days,issuedCount,availableCount:parseFloat(parseFloat(quantity)-parseFloat(issuedCount)),quantity,return_date:moment(myDate),book_quantity_detail_id,bookQuantityData:res.data.data,preloader:false,accessView:true});
            }
        });    
    }

    qrcode(Qrcode){
        this.setState({preloader:true });
         
        xhr.get(qrcodeUrl+'/'+Qrcode).then((res)=>{
            if(res.data.status===200){
                let datam =res.data.data;
                if(res.data.type==='book'){
                    const { title,book_id,no_of_due_days_student,no_of_due_days_staff,issuedCount,quantity,book_quantity_detail_id,code} =datam; 
                    const no_days=this.state.member_type==='student' ? no_of_due_days_student:no_of_due_days_staff;
                    const {issue_date}=this.state;
                    var myDate = new Date(new Date(issue_date).getTime()+no_days*24*60*60*1000);

                    this.setState({accessView:false,book_name:title,book_id:book_id,bookList:[],no_days,return_date:moment(myDate),qr_code:false ,preloader:false,issuedCount,availableCount:parseFloat(parseFloat(quantity)-parseFloat(issuedCount)),quantity,book_quantity_detail_id,accessCode:code});
                }
                if(res.data.type!=='book'){
                    const { user_id, name, id_no } =datam; 
                    this.setState({member_name:name, member_id:user_id,memberList:[],qr_code:false,preloader:false,id_no });
                }
            }else{
                this.setState({qr_code:false,preloader:false});
                const msg =res && res.data.msg?res.data.msg:'Please enter required feilds...';
                toast.error(msg);
            }
        }).catch((e)=>{
            this.setState({qr_code:false,preloader:false});
            // toast.error(e);
        });
        // xhr.cancel(requestId);
    }
    enableQR=()=>{
        this.setState({qr_code:true });
    }
    
    render() {
        const {pagetitle,preloader,book_name,issue_date,status,memberList,member_name,member_type,bookList,return_date,qr_code,issuedCount, availableCount,quantity,book_status,accessView,bookQuantityData,book_quantity_detail_id,accessCode,id_no} = this.state;

        const role=permissionCheck('book',pagetitle);
        if(!role)
            return <Nopermission/>;
        
        const book_nameValid = this.validator.message('Book Name',book_name, 'required');
        const issue_dateValid = this.validator.message('issue_date',issue_date, 'required');
        const member_nameValid = this.validator.message('Member Name',member_name, 'required');
        const member_typeValid = this.validator.message('Member Type',member_type, 'required'); 
        const return_dateValid = this.validator.message('Return Date',return_date, 'required'); 
        const book_quantity_detail_idValid = this.validator.message('Book Access Code',book_quantity_detail_id, 'required'); 

        let css= {
            position: 'fixed',
            overflow: 'auto',
            zIndex:1,
            maxHeight: '35%',
        };
        return (
            <div id="page_content_inner" className="uk-width-medium-6-10 uk-container-center">
                <h3 className="heading_b uk-margin-bottom">{pagetitle} Book Issue</h3>
                <div className="md-card">
                    <div className="md-card-content small-padding">
                        
                        <div className="uk-grid">
                            <div className="uk-width-large-1-2"> 
                                { qr_code? <Qrcode qrcode={(e)=>this.qrcode(e)}/>:<button type="button" onClick={this.enableQR} className="md-btn md-btn-small md-btn-primary md-btn-wave-light waves-effect waves-button waves-light">Show QR-Code Scanner</button>
                                }
                            </div>
                        </div>
                         
                        <div className="uk-grid">
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${member_type ? 'md-input-filled' : ''}`}>
                                    <select id="select_demo_1" className="md-input" name="member_type" onChange={this.setStateFromInput} value={member_type}>
                                        <option value="">Select Member Type</option>
                                        <option value="staff">Staff</option>
                                        <option value="student">Student</option>
                                    </select> 
                                    {member_typeValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${member_name ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Member Name">Member Name<span className="req">*</span></label> 
                                    <Autocomplete inputProps={{ className: 'md-input' }} wrapperStyle={{display:'inline',zIndex:'102',height:'200'}}
                                        menuStyle={css}
                                        getItemValue={(item) => item.value}
                                        items={memberList}
                                        renderItem={(item, isHighlighted,i) =>
                                            <div key={item.result.id} style={{ background: isHighlighted ? 'lightgray' : 'white',zIndex:'102' }}>
                                                {item.value}
                                            </div>
                                        }
                                        value={member_name}
                                        onChange={(e) =>this.onChangetext(e)}
                                        onSelect={this.onSelectedtext.bind( this )}
                                    />
                                    {member_nameValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${id_no ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Access Code">Id No</label>
                                    <input type="text" value={id_no}  className={ 'md-input '} readOnly />  
                                </div>
                            </div> 
                        </div> 

                        <div className="uk-grid">
                            <div className="uk-width-medium-1-2"> 
                                <div className={ `md-input-wrapper ${book_name ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Book Name">Book Name<span className="req">*</span></label> 
                                    <Autocomplete inputProps={{ className: 'md-input' }} wrapperStyle={{display:'inline',zIndex:'102',height:'200'}}
                                        menuStyle={css}
                                        getItemValue={(item) => item.value}
                                        items={bookList}
                                        renderItem={(item, isHighlighted,i) =>
                                            <div key={item.result.id} style={{ background: isHighlighted ? 'lightgray' : 'white',zIndex:'102' }}>
                                                {item.value}
                                            </div>
                                        }
                                        value={book_name}
                                        onChange={(e) =>this.onChangeBook(e)}
                                        onSelect={this.onSelectedBook.bind( this )}
                                    />
                                    {book_nameValid} 
                                </div>
                            </div> 
 

                            <div className="uk-width-medium-1-2"> 

                                {
                                    accessView &&
                                <select id="book_quantity_detail_id" className="md-input" name="book_quantity_detail_id" onChange={this.setStateFromInput} value={book_quantity_detail_id}>
                                    <option value="">Select Access Code</option>
                                    {
                                        bookQuantityData && bookQuantityData.map((val,i)=>{
                                            return(
                                                <option key={i} value={val.book_quantity_detail_id} >{val.code}</option>
                                            );
                                        })
                                    } 
                                </select> 
                                }
                                {
                                    !accessView &&

                                <div className={ `md-input-wrapper ${accessCode ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Access Code">Access Code</label>
                                    <input type="text" value={accessCode}  className={ 'md-input '} readOnly />  
                                </div>
                                }
                                {book_quantity_detail_idValid}
                            </div> 
                        </div>

                        <div className="uk-grid">
                            <div className="uk-width-medium-1-3"> 
                                <div className={ 'md-input-wrapper md-input-filled '}>
                                    <label htmlFor="Quantity">Quantity</label>
                                    <input type="text" name="quantity" value={quantity}  className={ 'md-input '} readOnly />  
                                </div>
                            </div> 
                            <div className="uk-width-medium-1-3"> 
                                <div className={ 'md-input-wrapper md-input-filled '}>
                                    <label htmlFor="Issued Quantity">Issued Quantity</label>
                                    <input type="text" name="issuedCount" value={issuedCount}  className={ 'md-input '} readOnly/>  
                                </div>
                            </div> 
                            <div className="uk-width-medium-1-3"> 
                                <div className={ 'md-input-wrapper md-input-filled '}>
                                    <label htmlFor="Available Qunatity">Available Qunatity</label>
                                    <input type="text" name="availableCount" value={availableCount}  className={ 'md-input '} readOnly/>  
                                </div>
                            </div> 
                        </div>

                        <div className="uk-grid">
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${issue_date ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Mobile">Book Issue Date<span className="req">*</span></label>
                                    <DatePicker selected={issue_date} minDate={moment().add(0, 'days')} dateFormat="DD/MM/YYYY" className="datepicker md-input"  disabled={true}/>
                                    {issue_dateValid} 
                                </div>
                            </div> 

                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${return_date ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Book Return Date">Book Return Date<span className="req">*</span></label>
                                    <DatePicker selected={return_date} dateFormat="DD/MM/YYYY" className="datepicker md-input" disabled={true}/> 
                                </div>
                            </div> 
                            <div className="uk-width-medium-1-3"> 
                                <div className="md-input-wrapper md-radio">
                                    <span className="md-radio">
                                        <input checked={status==1?1:0} onChange={this.setStateFromInput} type="radio" name="status" id="radio_demo_1" value="0" />
                                        <label htmlFor="radio_demo_1" className="inline-label">Active</label>
                                        <input type="radio" name="status" id="radio_demo_2" checked={status==0?1:0} onChange={this.setStateFromInput} value="1" />
                                        <label htmlFor="radio_demo_2" className="inline-label">Inactive</label>
                                    </span>
                                </div>
                            </div> 
                        </div>
                        
                        
                        <div className="uk-grid">
                            <div className="uk-width-1-1 btn-right-align">
                                <Link to={backUrl} className="md-btn md-btn-small md-btn-danger md-btn-wave-light waves-effect waves-button waves-light">Cancel</Link>
                                { book_status!==2 &&
                                <button type="button" onClick={this.submitForm} className="md-btn md-btn-small md-btn-primary md-btn-wave-light waves-effect waves-button waves-light">Submit</button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                { preloader && <Preloader/> }
            </div>  
        );
    }
}
 

export default AddEditAction;


// WEBPACK FOOTER //
// ./src/components/Library/BookIssueReturn/addEdit.js